import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class TicketService {

    constructor(private api: ApiService) { }

    addTicketData(data:any): Observable<any> {
      return this.api.post(environment.createTicket,data);
    }

    updateTicket(data:any): Observable<any> {
      return this.api.post(environment.updateTicket,data);
    }

    getAllTinaTicket(data:any): Observable<any> {
      return this.api.post(environment.getAllTinaTicket,data);
    }

    getFilteredTickets(data:any): Observable<any> {
      return this.api.post(environment.getFilteredTickets,data);
    }

    deleteTicket(data:any): Observable<any> {
      return this.api.post(environment.deleteTicket,data);
    }

    updateBulkTicket(data:any): Observable<any> {
      return this.api.post(environment.updateBulkTicket,data);
    }

    addTicketComment(data:any): Observable<any> {
      return this.api.post(environment.addTicketComment,data);
    }

    getAllTicketComments(data:any): Observable<any> {
      return this.api.post(environment.getAllTicketComments,data);
    }

    updateTicketComment(data:any): Observable<any> {
      return this.api.post(environment.updateTicketComment,data);
    }













  
 
    getTinaTicketHistory(data:any):Observable<any> {
      return this.api.post(environment.getTinaTicketHistory,data);
    }
    getAllZendeskTicket(data:any): Observable<any> {
        return this.api.post(environment.getAllZendeskTicket,data);
      }
    
    getUser(data:any): Observable<any> {
      return this.api.post(environment.getUsers,data);
    }
    getLead(data:any): Observable<any> {
      return this.api.post(environment.getLead,data);
    }

  
    updateTicketHistory(data:any): Observable<any> {
      return this.api.post(environment.updateTicketHistory,data);
    }
    createBulkTicketHistory(data:any): Observable<any> {
      return this.api.post(environment.createBulkTicketHistory,data);
    }
    addLeadFollowUp(data:any): Observable<any> {
      return this.api.post(environment.createleadsfollowup,data);
    }
    
    
    
  }

